export const base_url = `${process.env.REACT_APP_SERVICE_URL_BOOKING}`;

export const checkPromote = (item) =>{
    var week = new Date().getDay()
    var in_range = (week >= item.day_from && week <= item.day_to)
    return in_range ? item.price_2 : item.price
}